import { render, staticRenderFns } from "./UpdateConfig.vue?vue&type=template&id=2ebcc53b&scoped=true&"
import script from "./UpdateConfig.vue?vue&type=script&lang=ts&"
export * from "./UpdateConfig.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateConfig.vue?vue&type=style&index=0&id=2ebcc53b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebcc53b",
  null
  
)

export default component.exports